import React, { useState } from 'react';
import { Box, Typography, Collapse, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AlertsContainer from './AlertsContainer';
import ArchiveAlertActions from './ArchiveAlertActions';
import UnarchiveAlertActions from './UnarchiveAlertActions';

const AlertsDisplay = ({ alerts, archivedAlerts, archiveAlert, unarchiveAlert, isArchiving }) => {
  const [archivedExpanded, setArchivedExpanded] = useState(false);

  return (
    <Box sx={{ maxHeight: '300px', minHeight: '300px', overflowY: 'auto', scrollbarGutter: 'stable', pr: 1 }}>
      <Box sx={{ minHeight: '230px' }}>
        <AlertsContainer
          alerts={alerts}
          clickHandler={(id, all) => archiveAlert(id, all)}
          actionsComponent={ArchiveAlertActions}
          isArchiving={isArchiving}
          isArchivedSection={false}
        />
      </Box>
      {archivedAlerts.length > 0 && (
        <>
          <Box
            onClick={() => setArchivedExpanded(!archivedExpanded)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              mt: 2,
              mb: 1,
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.7,
              },
            }}
          >
            <IconButton
              size="small"
              sx={{
                transform: archivedExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s',
                padding: 0,
              }}
            >
              <ExpandMoreIcon fontSize="small" />
            </IconButton>
            <Typography variant="caption" color="text.secondary">
              Archived ({archivedAlerts.length})
            </Typography>
          </Box>
          <Collapse in={archivedExpanded} timeout="auto" unmountOnExit>
            <AlertsContainer
              alerts={archivedAlerts}
              clickHandler={(id) => unarchiveAlert(id)}
              actionsComponent={UnarchiveAlertActions}
              isArchiving={isArchiving}
              isArchivedSection={true}
            />
          </Collapse>
        </>
      )}
    </Box>
  );
};

export default AlertsDisplay;
